"use strict";

exports.__esModule = true;
var _DeviceDataItemBatchSubscription = require("./DeviceDataItemBatchSubscription");
Object.keys(_DeviceDataItemBatchSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDataItemBatchSubscription[key]) return;
  exports[key] = _DeviceDataItemBatchSubscription[key];
});